import { render, staticRenderFns } from "./hotTopicDetails.vue?vue&type=template&id=99971076&scoped=true"
import script from "./hotTopicDetails.vue?vue&type=script&lang=js"
export * from "./hotTopicDetails.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/hotTopicDetails.css?vue&type=style&index=0&id=99971076&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99971076",
  null
  
)

export default component.exports